import { FormType, ReportJSON } from '@aloft/toolkit-shared';

import FileSaver from 'file-saver';

import { generateClickFormsTxt } from './generateClickFormsTxt.ts';

type SaveClickFormsFileArgs = {
  compSequence: string[];
  reportJSON: ReportJSON;
  zipName: string;
  formType: FormType;
  isMerge: boolean;
};

export const saveClickFormsFile = async ({
  compSequence,
  reportJSON,
  zipName,
  formType,
  isMerge,
}: SaveClickFormsFileArgs) => {
  const clickFormsTxt = await generateClickFormsTxt({
    compSequence,
    reportJSON,
    formType,
    isMerge,
  });

  const blob = new Blob([clickFormsTxt], { type: 'text/plain; charset=utf-8' });

  FileSaver.saveAs(blob, `${zipName}.txt`);
};
